import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { interval as observableInterval, Observable, Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import { AppState, SESSION_LENGTH } from 'src/app';

import { SessionService } from 'src/core/services/session.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'inactivity-detector',
  templateUrl: './inactivityDetector.component.html',
  styleUrls: ['./inactivityDetector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InactivityDetectorComponent implements OnInit, OnDestroy {
  THRESHOLD: number = 5 * 60 * 1000;
  TIME_TO_WAIT: number = SESSION_LENGTH.INACTIVITY * 60 * 1000;
  TIME_TO_SHOW_MODAL: number = this.TIME_TO_WAIT - this.THRESHOLD;

  // modal
  activityListener: any;
  thresholdListener: any;
  showModal = false;

  // time
  timeLeft: any;
  inactiveSince: any;
  checkExpiringTimeObservable$: Observable<any> = observableInterval(1000);
  checkExpiringTimeSubscription: Subscription;

  public isModalClosing: boolean;

  constructor(
    private sessionService: SessionService,
    private store: Store<AppState>,
  ) {}

  ngOnDestroy() {
    if (this.checkExpiringTimeSubscription) {
      this.checkExpiringTimeSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.startListeningForActivity();
  }

  startListeningForActivity() {
    this.inactiveSince = new Date();

    this.thresholdListener = setInterval(() => {
      this.showModal = true;
    }, this.TIME_TO_SHOW_MODAL);

    this.activityListener = setInterval(() => {
      this.doLogout();
    }, this.TIME_TO_WAIT);

    this.checkExpiringTimeSubscription =
      this.checkExpiringTimeObservable$.subscribe(() => {
        this.timeLeft = this.getTimeLeftToExpire();
        if (this.timeLeft === '00:00') {
          this.doLogout();
        }
      });
  }

  doLogout() {
    if (this.checkExpiringTimeSubscription) {
      this.checkExpiringTimeSubscription.unsubscribe();
    }

    this.sessionService.logout(true);
  }

  doRefresh($event?: any) {
    this.clearIntervals();
    this.startListeningForActivity();

    this.cancelConfirmation();
  }

  clearIntervals() {
    clearInterval(this.thresholdListener);
    clearInterval(this.activityListener);
  }

  getTimeLeftToExpire(): string {
    const currentDate: any = new Date();
    const minutes: number = Math.abs(currentDate - this.inactiveSince);
    const ss: number = minutes / 1000;
    const ssToExpire: number = SESSION_LENGTH.INACTIVITY * 60 - ss;
    const seconds: number = ssToExpire < 0 ? 0 : ssToExpire;

    let mmExp: any = ~~(seconds / 60); // tslint:disable-line
    let ssExp: any = ~~(seconds % 60); // tslint:disable-line

    mmExp = mmExp < 10 ? '0' + mmExp : mmExp;
    ssExp = ssExp < 10 ? '0' + ssExp : ssExp;

    return `${mmExp}:${ssExp}`;
  }

  cancelConfirmation() {
    // This allows the animation to be rendered, unmounting the modal element
    // after the animation has ended.
    this.isModalClosing = true;
    setTimeout(() => {
      this.showModal = false;
      this.isModalClosing = false;
    }, 400);
  }

  @HostListener('body:scroll', ['$event']) onUserScroll($event: any) {
    this.doRefresh();
  }

  @HostListener('body:click', ['$event']) onUserClicks($event: any) {
    this.doRefresh();
  }
}
